import type { ReconciliationFilters } from '../types';
import { SortOrders } from '@/graphql/generated';

export const getReconciliationDefaultFilters = (mounth?: string): ReconciliationFilters => ({
  searchString: null,
  mounth: mounth || null,
  status: null,
  pagination: {
    page: 1,
    pageSize: 50,
  },
  sort: {
    key: null as string | null,
    order: SortOrders.Desc,
  },
});

export const SORT_COLUMN_MAP: Record<string, string> = {
  'commonInfo.orderNumber': 'reconciliationItemTitle',
  'commonInfo.period': 'period',
  'commonInfo.orderReconciliationStatus': 'orderReconciliationStatus',
  'commonInfo.orderAvoidanceStatus': 'orderAvoidanceStatus',
};
